import {createReducer} from "typesafe-actions";
import {ViewType} from "../../../models/api/codegen/code";
import {CHANGE_VIEW, getPlayerInfoAsync} from "../actions";

export const view = createReducer<ViewType>("LOADING")
    .handleAction(CHANGE_VIEW, (state, action) => action.payload)
    .handleAction(getPlayerInfoAsync.success, () => "ALL")
    .handleAction(getPlayerInfoAsync.failure, () => "ERROR")